/**
 * Created by greg on 19/07/2018.
 */
import { Component, Input, ElementRef } from '@angular/core';
import { unknownDateToDate } from 'globals/helpers/helpers';
import { DatePipe } from '@angular/common';

@Component({
    selector: '[appdatetime]',
    template: `{{typeof(datetime) === 'string' ? datetime : correct(datetime) | date:format}}`,
    standalone: true,
    imports: [DatePipe],
})
export class DatetimeComponent {
    @Input('appdatetime') datetime;
    @Input('format') format = 'E dd MMM'; // , HH:mma';

    constructor(public el: ElementRef) {}
    correct(input) {
      if (!input) return
      return unknownDateToDate(input)
    }
    typeof(v) {
        return typeof v;
    }
}
